// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1NiV5","checkboxCol":"Table_checkboxCol__1aw6P","emailCol":"Table_emailCol__1v89N","actionCol":"Table_actionCol__1zhEt"};